import { useCallback, useEffect, useState } from "react";
import {
	getRenewDashboardList,
	getRenewMonthDashboardList,
	getRenewTop3EnsoStatDtoList,
	getRenewIcehDashboardList,
	getRenewIcehTop3EnsoStatDtoList,
	getRenewIcehMonthDashboardList,
	getPreviousMonthCount
} from "../../../../service/monitor/renewStatService";

export const useRenewData = ({ conn, rgnCode, bizType }) => {
	const [data, setData] = useState();

	const fetchData = useCallback(async () => {
		let response;
		
		if (bizType === 'rps') {
            response = await Promise.all([
                getRenewIcehDashboardList(conn),
                getRenewIcehTop3EnsoStatDtoList(conn, rgnCode),
                getRenewIcehMonthDashboardList(conn),
            ]);
        } else {
            response = await Promise.all([
                getRenewDashboardList(conn),
                getRenewTop3EnsoStatDtoList(conn, rgnCode),
                getRenewMonthDashboardList(conn),
				getPreviousMonthCount(conn, rgnCode),
            ]);
        }

		setData(response);
	}, [rgnCode, bizType]);

	useEffect(() => {
		fetchData();
		const interval = setInterval(fetchData, 1000 * 60);
		return () => clearInterval(interval);
	}, [fetchData])

	return {
		dashboardList: data && data[0],
		top3EnsoStatDtoList: data && data[1],
		monthDashboardList: data && data[2],
    previousMonthCount: data && data[3],
	};
}